import { Outlet, useLocation } from 'react-router-dom'
import Sidebar from '../../components/Sidebar/Sidebar'
import Socket from '../../sockets/socket'
import HelpTip from '../../components/Help/HelpTip'

// Help topics for the screen that is open (keys come from the help articles)
const getHelpContext = (pathname) => {
  if (/\/extensions\//.test(pathname)) return 'extensions'
  if (/\/organization\/[^/]+\/(add|edit)$/.test(pathname) || /\/organization\/add$/.test(pathname))
    return 'organization'
  if (/\/organization\/[^/]+$/.test(pathname) || /\/plans-bundles/.test(pathname)) return 'plans'
  if (/\/organizations/.test(pathname)) return 'organization'
  return undefined
}

const Dashboard = () => {
  const { pathname } = useLocation()
  return (
    <>
      <Socket />
      <Sidebar />
      <div className='container-fluid overflow-auto d-flex'>
        <div className='container-fluid main-wrapper '>
          <div className='help-button-wrapper'>
            <HelpTip context={getHelpContext(pathname)} label='Help and search' />
          </div>
          <Outlet />
        </div>
      </div>
    </>
  )
}

export default Dashboard
